import signin from '../signin'

const unsubscribe = (type, id) => {
  const payload = {
    event: type, //"unsubscribe_website" para quando fechar o acordo, "unsubscribe" pela tela de unsubscribe
    data: {
      person_uuid: id,
    },
  }

  return signin('hermes').then(({ http }) => {
    return http.post('/', payload).then((data) => {
      console.log(data)
      return data
    })
  })
}

export default {
  unsubscribe,
}
